import React, { useState } from "react";
import { navItems } from "../../utils/navbar";
import { Container, Menu, NavbarLink, NavLinks, NavbarItem, Title, Toggle } from "./style";
import { useHistory } from "react-router-dom";
export default function Navbar() {
  const history = useHistory();
  const main = () => {
    history.push("/home");
  };
  const [toggle, setToggle] = useState(false);
  const onToggle = () => {
    setToggle(!toggle);
  };
  return (
    <Container>
      <Container header>
        <Title onClick={main}>Sardorbek</Title>
        <Toggle>
          {!toggle ? (
            <Container onClick={onToggle} menuBtn></Container>
          ) : (
            <Menu>
              <Container onClick={onToggle} closeBtn></Container>
              <NavbarItem>
                {navItems.map(({ path, title, child }, index) => {
                  return (
                    <div key={index} style={{ padding: "10px 0", margin: "0 100px 0 0 " }}>
                      <NavLinks onClick={onToggle} activeStyle={{ color: "crimson", borderRadius: "50px" }} to={path}>
                        {title}
                      </NavLinks>
                    </div>
                  );
                })}
              </NavbarItem>
            </Menu>
          )}
        </Toggle>
        <Container navigation>
          {navItems.map(({ path, title, child }, index) => {
            return (
              <NavbarLink key={index} activeStyle={{ color: "crimson" }} to={path}>
                {title}
              </NavbarLink>
            );
          })}
        </Container>
      </Container>
    </Container>
  );
}
